export const buildUrl = (
    baseUrl: string,
    params: Record<string, string | number | undefined | null>
): string => {
    const filteredParams = Object.entries(params).filter(
        ([, value]) => value !== "" && value != null
    );
    const queryString = new URLSearchParams(
        filteredParams as [string, string][]
    ).toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
